// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { buttonTransparent } from "@hardwoods/XDL/PreStyle/button";
import { color } from "@hardwoods/XDL/Utilities";
import { ButtonIconPresentationProps, ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import { getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface FilterHeaderStyle {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countNumber?: InjectableCss;
    toggleFilterGridItem?: GridItemProps;
    headingText?: InjectableCss;
    headingItem?: InjectableCss;
    orderCountText?: InjectableCss;
    toggleFilterButtonIcon?: ButtonIconPresentationProps;
    toggleFilterButton?: ButtonPresentationProps;
    clearFiltersButton?: ButtonProps;
    appliedFiltersContainer?: InjectableCss;
}

export const filterHeaderStyle: FilterHeaderStyle = {
    // Header Section
    container: {
        gap: 0,
    },
    countGridItem: {
        width: 7,
        css: css`
            order: 1;
            align-items: flex-end;
            justify-content: flex-end;
            font-size: 16px;
            font-weight: 400;
        `,
    },

    countNumber: {
        css: css`
            display: inline-block;
            margin-right: 3px;
            font-weight: bold;
        `,
    },

    toggleFilterGridItem: {
        width: 5,
        css: css`
            justify-content: flex-start;
        `,
    },

    headingText: {
        css: css`
            padding-left: 5px;
            margin-bottom: 0;
            font-weight: 400;
            font-size: 18px;
            display: block;
        `,
    },
    headingItem: {
        css: css`
            display: none;
        `,
    },
    orderCountText: {
        css: css`
            justify-content: flex-end;
            display: flex;
        `,
    },
    toggleFilterButtonIcon: {
        mergeCss: true,
        src: Filter,
        size: 20,
        color: "text.main",
        css: css`
            &&& {
                width: 65px;
                position: relative;
                font-weight: 400;
                font-size: 18px;
                color: ${color("text")};
            }
            &::after {
                content: "Filter";
                position: absolute;
                top: 50%;
                right: 0px;
                transform: translateY(-50%);
                font-size: 18px;
                font-weight: 400;
                color: ${color("text")};
            }
        `,
    },
    clearFiltersButton: {
        variant: "tertiary",
        css: css`
            border-radius: 3px;
        `,
    },
    appliedFiltersContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            margin-bottom: 10px;
            &:empty {
                display: none;
            }
        `,
    },
    toggleFilterButton: {
        mergeCss: true,
        css: css`
            justify-content: center;
            border: 1px solid ${color("common.border")};
            border-radius: 0;
            background: ${color("common.ui3")};
            padding: 8px 15px;
            min-width: 140px;
            &:disabled {
                background: ${color("common.disabled")};
                border-color: ${color("common.disabled")}; // to remove border-color from OOTB
            }

            &:hover:not([disabled]) {
                background: ${color("common.ui3")};
                border: 1px solid ${color("common.border")};
            }

            &:focus:not([disabled]) {
                background: ${color("common.ui3")};
                border: 1px solid ${color("common.border")};
                outline-offset: 0px;
                outline-color: ${getProp("theme.focus.color", "#09f")};
            }
        `,
    },
};
